const modelName = 'Product Sub Categories';
const modelNameSingular = 'Product Sub Category';
const endpoint = '/sub-categories';

const setup = {
    title: modelName,
    singular: modelNameSingular,
    model: modelName.replace(/\s+/g, '-').toLowerCase(),
    canDelete: true,
    canAddNew: true,
    canSearch: true,
    endpoint,
    accessor: 'id',
};

export default setup;
